import { render, staticRenderFns } from "./ProducerSellComponent.vue?vue&type=template&id=36d41cb4&scoped=true"
import script from "./ProducerSellComponent.vue?vue&type=script&lang=js"
export * from "./ProducerSellComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d41cb4",
  null
  
)

export default component.exports